import { IntrusionArmMode } from '@/graphql/types';

import type { IntrusionPartitionActionOption, IntrusionZoneActionOption } from './types';

export const INTRUSION_PARTITION_STATUSES = {
  DISARMED: 'Disarmed',
  READY: 'Ready',
  NOT_READY: 'Not Ready',
  ARMED_STAY: 'Armed Stay',
  ARMED_AWAY: 'Armed Away',
  ARMED_NIGHT: 'Armed Night',
  ALARM: 'Alarm',
  EXIT_DELAY: 'Exit Delay',
  ENTRY_DELAY: 'Entry Delay'
} as const;

export const INTRUSION_ZONE_STATUSES = {
  CLOSED: 'Closed',
  OPEN: 'Open',
  ALARM: 'Alarm',
  TROUBLE: 'Trouble',
  BYPASSED: 'Bypassed'
} as const;

export const INTRUSION_PARTITION_STATE_MATCHERS = {
  DISARMED: ['Disarmed'],
  NOT_READY: ['Not Ready'],
  READY: ['ReadyToArm', 'Ready'],
  ARMED_AWAY: ['AwayArmed', 'ArmedAway'],
  ARMED_STAY: ['StayArmed', 'ArmedStay'],
  ARMED_NIGHT: ['NightModeArmed', 'ArmedNight']
} as const;

export const INTRUSION_ZONE_STATE_MATCHERS = {
  BYPASSED: ['Bypass'],
  TROUBLE: ['Trouble', 'Tamper', 'Fault'],
  ALARM: ['Alarm'],
  OPEN: ['Open'],
  CLOSED: ['Closed']
} as const;

export const INTRUSION_PARTITION_TRANSITION_MATCHERS = {
  EXIT_DELAY: ['ExitDelay'],
  ENTRY_DELAY: ['EntryDelay']
} as const;

/** Real vEvents `type` values for zone/partition state-change events (open/closed, armed/disarmed, delay). */
export const INTRUSION_STATE_EVENT_TYPES = new Set<string>(['ZoneState', 'PartitionState']);

export const INTRUSION_ALARM_EVENT_TYPES = new Set<string>(['ZoneAlarm', 'PartitionAlarm']);

export const PARTITION_ACTION_OPTIONS: readonly IntrusionPartitionActionOption[] = [
  {
    id: 'arm-stay',
    label: 'Arm Stay',
    armMode: IntrusionArmMode.StayArmed
  },
  {
    id: 'arm-away',
    label: 'Arm Away',
    armMode: IntrusionArmMode.AwayArmed
  },
  {
    id: 'arm-night',
    label: 'Arm Night',
    armMode: IntrusionArmMode.NightModeArmed
  },
  {
    id: 'disarm',
    label: 'Disarm',
    armMode: IntrusionArmMode.Disarmed,
    variant: 'danger'
  }
] as const;

export const ZONE_ACTION_OPTIONS: readonly IntrusionZoneActionOption[] = [
  { id: 'bypass', label: 'Bypass', value: 'bypass' },
  { id: 'unbypass', label: 'Unbypass', value: 'unbypass' }
] as const;
